module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-800italic.a69f0add9d86c1a84311d7dd8693ba4a.woff";